module.exports = __webpack_public_path__ + "media/images/svgs/jersey-icon-f17417280baac8a74384e63042c37371.svg";